import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink, Container, Col, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import { clientUrls } from '../Utils/Urls';
import { colors } from '../Utils/Colors';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import axios from 'axios';
import { serverUrls } from '../Utils/Urls';
import { logout, logoutSuccess, logoutFailure } from '../Actions/logoutAction';
import { redirectTo } from '../Utils/RedirectUtil';

const style = {
    backgroundColor: colors.darkGrey,
};

const linkStyle = {
    color: colors.white
};

const CustomAlert = (props) => {
    const [visible, setVisible] = useState(true);

    const onDismiss = () => setVisible(false);

    return (
        <Alert color={props.color} isOpen={visible} toggle={onDismiss}>
            {props.message}
        </Alert>
    );
}

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.toggleNavbar = this.toggleNavbar.bind(this);    
        this.state = {
            collapsed: true
        }
    }

    logout = (e) => {
        e.preventDefault();
        this.props.logout();
    }

    toggleNavbar = () => {
        this.setState({
            collapsed: !this.state.collapsed
        })
    }

    render() {
        let errorMessages = [(<br key ={"br"} />)];
        if(Object.keys(this.props.errors).length > 0) {
            Object.keys(this.props.errors).forEach((element) => {
                var message = this.props.errors[element][0];
                if(message.includes("This")) {
                    message = message.replace("This", element);
                } else if(message.includes("this")) {
                    message = message.replace("this", element);
                }
                errorMessages.push((
                    <CustomAlert key={element} message={message} color="danger"/>
                ));
            });
        }
        let successMessages = [(<br key ={"br"} />)];
        if(Object.keys(this.props.success).length > 0) {
            Object.keys(this.props.success).forEach((element) => {
                var message = this.props.success[element][0];
                if(message.includes("This")) {
                    message = message.replace("This", element);
                } else if(message.includes("this")) {
                    message = message.replace("this", element);
                }
                successMessages.push((
                    <CustomAlert key={element} message={message} color="success"/>
                ));
            });
        }
        return (
            <div>
                {this.props.isLoggedIn?
                <Navbar style={style} expand="md" light>
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                    <Collapse isOpen={!this.state.collapsed} navbar>
                        <Container>
                            <Col sm="12" >
                                <Nav navbar>
                                    <NavItem>
                                        <NavLink style={linkStyle} tag={Link} to={clientUrls.home}>Home</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={linkStyle} tag={Link} to={clientUrls.newPatient}>Add Patient</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={linkStyle} tag={Link} to={clientUrls.viewPatient}>View Patient</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={linkStyle} tag={Link} to={clientUrls.changePass}>Change Password</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={linkStyle} onClick={this.logout} >Logout</NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Container>
                    </Collapse>
                </Navbar>
                :null}
                <Container>    
                    {this.props.loading?(
                        <div>
                            <br/>
                            <Spinner style={{ width: '3rem', height: '3rem' }} />
                        </div>
                    ):null}
                    {Object.keys(this.props.errors).length>0?errorMessages:null}
                    {Object.keys(this.props.success).length>0?successMessages:null}
                </Container>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        loading: state.loadingAndError.loading,
        errors: state.loadingAndError.errors,
        success: state.loadingAndError.success,
        isLoggedIn: state.user.isLoggedIn
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            dispatch(logout({loading: true}));
            axios.get(serverUrls.logout).then((res)=>{
                dispatch(logoutSuccess({loading: false}));
                redirectTo('/');
            }).catch((err)=>{
                dispatch(logoutFailure({loading: false, errors: {error: ["Something Went Wrong"]} }));
            })
        }
    }
}

  
export default connect(mapStateToProps, mapDispatchToProps)(Header);